import { slugify } from "@/lib/utils";

/**
 * Enlace interno a la ficha pública de un producto.
 *
 * Siempre apunta a la URL canónica `/productos/<numericId>-<slug>` cuando hay
 * numericId: enlazar a `/comparador/<id>` obligaba a Google a pasar por un
 * redirect y diluía la autoridad interna que reciben las fichas. Solo los
 * productos sin numericId (casos legados) caen en la ruta vieja.
 */
export function productHref(p: {
  id?: string | null;
  globalProductId?: string | null;
  numericId?: number | null;
  name?: string | null;
}): string {
  if (p.numericId && p.name) return `/productos/${p.numericId}-${slugify(p.name)}`;
  return `/comparador/${p.globalProductId || p.id}`;
}
